import { handleFirstCheck, handleSecondCheck, handleCanLearnCheck } from '@/api/grt/courseCommend';
import ToastUtils from '@/utils/ToastUtils';
import { templateMap } from './constant';
import { isInApp, linkApp } from '@/utils/Mobile';

//兼容苹果浏览器不支持window.open
const openInNewTab = (url) => {
    setTimeout(() => {
        window.open(url);
    }, 50);
};
const webLearnEvent = {
    [templateMap.school]: (data) => {
        let { template_id, business_id, resource_id } = data;
        openInNewTab(
            `${window.location.origin}/web/player/parent-school?template_id=${template_id}&business_id=${business_id}&course_type=${template_id}&resource_id=${resource_id}`
        );
    }
};
const webDetailEvent = {
    [templateMap.school]: (data) => {
        let { template_id, business_id } = data;
        openInNewTab(
            `${window.location.origin}/web/business-detail?template_id=${template_id}&business_id=${business_id}&course_type=${template_id}`
        );
    }
};
const mobileLearnEvent = {
    [templateMap.school]: (data) => {
        let { template_id, business_id } = data;
        openInNewTab(
            `${window.location.origin}/mobile/learning-detail/student/video?template_id=${template_id}&business_id=${business_id}&course_type=${template_id}`
        );
    }
};
const mobileDetailEvent = {
    [templateMap.school]: (data) => {
        let { template_id, business_id } = data;
        openInNewTab(`${window.location.origin}/mobile/detail?template_id=${template_id}&business_id=${business_id}&course_type=${template_id}`);
    }
};
//去详情页
export const goWebDetailPage = (data) => {
    webDetailEvent[data?.template_id](data);
};
export const goMobileDetailPage = (data) => {
    let isApp = isInApp();
    if (isApp) {
        linkApp(`grtedu://jump_template?template_id=${data?.template_id}&business_id=${data?.business_id}`);
        return;
    }
    mobileDetailEvent[data?.template_id](data);
};

//去学习页
export const goWebLearnPage = (data) => {
    webLearnEvent[data?.template_id](data);
};
export const goMobileLearnPage = (data) => {
    let isApp = isInApp();
    if (isApp) {
        linkApp(`grtedu://jump_study_template?template_id=${data?.template_id}&business_id=${data?.business_id}`);
        return;
    }
    mobileLearnEvent[data?.template_id](data);
};
export const handleGoLearn = (type, data, side = 'web') => {
    // let res = await handleCanLearnCheck({
    //     business_id: data?.business_id,
    //     template_id: data?.template_id
    // });
    // if (!res.success) {
    //     ToastUtils.showAbnormalToast(res.msg || '操作失败');
    //     return false;
    // }
    // 0 打开多项目弹窗

    //去学习页
    if (type === 1) {
        if (side === 'mobile') {
            goMobileLearnPage(data);
        } else {
            goWebLearnPage(data);
        }
    }
    //去详情页
    if (type === 2) {
        if (side === 'mobile') {
            goMobileDetailPage(data);
        } else {
            goWebDetailPage(data);
        }
    }
    return type;
};
//点击立即学习，第一次校验判断是直接跳转还是打开多项目选择
export const firstCheck = async (resource_id, side = 'web') => {
    let res = await handleFirstCheck({ resource_id });
    if (res && res.success && res?.data) {
        let list = res?.data?.business_list || [];
        if (res?.data?.state === 0) {
            return list;
        } else {
            if (list.length) {
                let params = { resource_id: resource_id, business_id: list[0]?.business_id, template_id: list[0]?.template_id };
                handleGoLearn(res.data?.state, params, side);
            }

            return false;
        }
    } else {
        ToastUtils.showAbnormalToast(res.msg || '操作失败');
    }
};
//第二次校验，判断跳转到哪个页面
export const secondCheck = async (data, side = 'web') => {
    let res = await handleSecondCheck(data);
    if (res && res.success) {
        handleGoLearn(res.data, data, side);
        return true;
    } else {
        ToastUtils.showAbnormalToast(res.msg || '操作失败');
        return false;
    }
};

//点击立即学习 需要验证是否在多项目
export const handleClickLearn = async (resource_id, side = 'web') => {
    let list = await firstCheck(resource_id, side);
    if (list) {
        // handleChoseList(list, resource_id);
        return list;
        console.log('打开多项目选择弹窗');
    }
    return false;
};
